import React, { useEffect, useContext } from 'react'
import { Form, Input } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useHistory } from 'react-router'
import { NavLink } from 'react-router-dom'
import { ReactComponent as MainEmailIcon } from 'assets/svg/login/main_email.svg'
import { ReactComponent as MainPasswordIcon } from 'assets/svg/login/main_password.svg'
import { ReactComponent as MainLogin } from 'assets/svg/login/main_login.svg'
import { signIn } from 'store/actions/auth'
import { AppUrls } from 'common/AppUrls'
import { getCallToNumberParam } from 'utils/urlUtils'
import { useTranslation } from 'react-i18next'
import { AppContext } from 'common/Globals'
import { WhitelabelConfig } from 'hooks'

export function LoginForm() {
    const { t } = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()
    const { isUserAuthed } = useContext(AppContext)
    const authError = useSelector((state) => state.auth.error)
    const showForgotPassword = !WhitelabelConfig?.forgotPasswordDisabled

    const number = getCallToNumberParam()

    const initialValues = {
        login_email: null,
        password: null
    }

    const validationSchema = yup.object().shape({
        login_email: yup.string().nullable().email(t('email_incorrect')).required(t('field_required')),
        password: yup.string().nullable().required(t('field_required'))
    })

    useEffect(() => {
        if (isUserAuthed && !number) {
            setTimeout(() => {
                history.push(AppUrls.dialpad)
            }, 1000)
        }
    }, [isUserAuthed, history, number])

    function onSubmit(values) {
        dispatch(signIn({ values }))
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => (
                <div className="login__form">
                    <Form.Item className="login__form-item" validateStatus={errors.login_email ? 'error' : null}>
                        <Input
                            name="login_email"
                            value={values.login_email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="app__input"
                            placeholder={t('email')}
                            prefix={<MainEmailIcon />}
                        />
                        {errors.login_email && touched.login_email && (
                            <p className="login__form-error">{errors.login_email}</p>
                        )}
                    </Form.Item>
                    <Form.Item className="login__form-item" validateStatus={errors.password ? 'error' : null}>
                        <Input
                            name="password"
                            type="password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="app__input"
                            placeholder={t('password')}
                            prefix={<MainPasswordIcon />}
                        />
                        {!authError && errors.password && touched.password && (
                            <p className="login__form-error">{errors.password}</p>
                        )}
                        {authError && <p className="login__form-error">{authError}</p>}
                    </Form.Item>

                    <button type="button" onClick={() => handleSubmit()} className="login__submit">
                        <MainLogin width={15} height={15} /> {t('login')}
                    </button>

                    {showForgotPassword && (
                        <div className="d-flex justify-content-center">
                            <NavLink to={AppUrls.passwordRecovery} className="login__forget-pass">
                                {t('forgot_password')}
                            </NavLink>
                        </div>
                    )}
                </div>
            )}
        </Formik>
    )
}
